export enum LmEntityStatusEnum{

    draft,
    pending,
    discarded,
    active,
    obsolete,
    deleted

}